import styled from 'styled-components'
import { Pill } from '@sainsburys-tech/bolt'

export const PillsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: ${props => props.theme.size.spacing.lg} 0;
`

export const StyledPill = styled(Pill)`
  background-color: ${props => props.theme.color.monochrome.lighter};
  color: ${props => props.theme.color.monochrome.darker};
  margin: ${props => props.theme.size.spacing.md};
  &:hover {
    background-color: ${props => props.theme.color.monochrome.light};
  }
`

export const StyledLink = styled.a`
  margin: ${props => props.theme.size.spacing.md};
  color: ${props => props.theme.color.alias.link.default.color};
  font-weight: ${props => props.theme.font.weight.bold};
  display: inline;
  position: relative;
  text-decoration: underline;
  &:hover {
    background-color: ${props => props.theme.color.alias.link.hover.background.color};
  }
`
